import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasImagenRepresentacionEmpresa from "../../hooks/usePreguntasImagenRepresentacionEmpresa";
import usePreguntasPredisposicion from "../../hooks/usePreguntasPredisposicion";

const PreguntasPredisposicion = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasPredisposicion();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Predisposición (6/6)"
			opciones={[
				{ key: "asistentePuntualmenteCapacitaciones", label: "Asiste puntualmente a las capacitaciones programadas" },
				{ key: "colaborarEnServiciosImprevistos", label: "Colabora en servicios imprevistos sin generar inconvenientes" },
				{ key: "informaConTiempoSinoPuedeRealizarUnServicio", label: "Informa con tiempo si no puede realizar un servicio asignado" }
			]}
		/>
	);
};

export default PreguntasPredisposicion;
